(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["burts-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript.closest('.shopify-section');
    if (!section) return;
    const root = section.querySelector('[data-burts-home-hero]');
    if (!root) return;
    const slides = [...root.querySelectorAll('[data-burts-home-slide]')];
    const dots = [...root.querySelectorAll('[data-burts-home-dot]')];
    if (slides.length < 2) return;

    let index = 0;
    let timer = null;

    const setActive = (nextIndex) => {
      index = nextIndex;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    const restart = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        const nextIndex = (index + 1) % slides.length;
        setActive(nextIndex);
      }, 6500);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setActive(Number(dot.dataset.slideIndex || 0));
        restart();
      });
    });

    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', restart);
    restart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
